<template>
  <WdsTag
    sm
    :success="column.status === ContactStatus.Active"
    :warning="column.status === ContactStatus.Invited"
    :data-test="`recruiter-status-${rowIndex}`"
  >
    {{ statusLabel }}
  </WdsTag>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsTag } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { ContactStatus } from '@/gql/graphql'
import { $t } from '@/composables/translation'

const CompanyRecruiterStatusColumn = graphql(`
  fragment CompanyRecruiterStatusColumn on CompanyRecruiter {
    status
  }
`)

const props = defineProps<{
  row: FragmentType<typeof CompanyRecruiterStatusColumn>
  rowIndex?: number
}>()
const column = computed(() => useFragment(CompanyRecruiterStatusColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)

const statusLabel = computed(() => {
  switch (column.value.status) {
    case ContactStatus.Applied:
      return $t('Applied')
    case ContactStatus.Blocked:
      return $t('Blocked')
    case ContactStatus.Declined:
      return $t('Declined')
    case ContactStatus.Invited:
      return $t('Invited')
    default:
      return $t('Active')
  }
})
</script>
